export const RADIO_OPTIONS = [
  { value: 'No tengo saldo en mi Gift Card' },
  { value: 'No funciona la clave de mi Gift Card' },
  { value: 'Mi Gift Card está bloqueada' },
];

export const PREFORM_FIELDS = [
  {
    name: 'giftCardNumber',
    inputAdornment: '',
    label: 'Nº de Gift Card',
    disabled: false,
    required: true,
    helper: 'Ingresa 7 o 20 dígitos',
  },
];
